import { Component, OnInit, Inject, OnDestroy, Input, AfterViewInit } from '@angular/core';
import { SharedService } from '../../common/shared.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { Location } from '@angular/common';
import { ToastrService } from "ngx-toastr";
import { APP_CONFIG, AppConfig } from '../../config/app.config.module';
import { Http } from '@angular/http';
import { SearchService } from '../../search/search.service';
import * as moment from 'moment';
// import 'moment/locale/ms-my';
import { ISubscription, Subscription } from 'rxjs/Subscription';
import { TopnavService } from '../../header/topnav/topnav.service';
import { PortalService } from '../../services/portal.service';
import { NavService } from '../../header/nav/nav.service';
import { environment } from '../../../environments/environment.local';
declare var jquery: any;
declare var $: any;

/**
 * Author: Sridhar Swaminathan
 * 
 * Date Created: November 14th 2017
 * 
 * Description: Component class for Search - /search
 **/
@Component({
  selector: 'app-search-result',
  templateUrl: './search-result.component.html',
  styleUrls: ['./search-result.component.css'],
})

export class SearchResultComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input()
  selectedIndex: any | null;

  errorMessage: any;
  observableGlobalItem: any;
  globVal: any;
  chknoncitizen: boolean = false;
  chkcitizen: boolean = false;
  lang:any;
  languageId: any = 1;
  contentLangId: any = 1;
  public loading = false;
  date: moment.Moment;
  dataEach = '';
  panelOpenState: boolean = false;
  selKey = "yes";
  align: string;
  tabIndex = 0;
  sKeyword = false; //side menu
  sSpeci = false; //side menu
  sFilter = false; //side menu
  intData: any[];
  aggrData: any[];
  ddauthor: any[];
  ddtopics: any[];
  ddmonthPub: any[];
  // arymonth: any[];
  ddsubTopics: any[];
  ddministry: any[];
  ddagency: any[];
  valMonPub: any[];
  valAuthor: any[];
  valTopic: any[];
  valSubTopic: any[];
  valMinistry: any[];
  valAgency: any[];
  selMonPubDisp = "";
  selAuthDisp = "";
  selTopicDisp = "";
  selSubTopicDisp = "";
  selMinisDisp = "";
  selAgencyDisp = "";
  ser_word = "";
  chkKeyValue = "1";
  inpExcWord = '';
  chktopic = true;
  chksubtopic = true;
  chktitle = true;
  chkdes = true;
  chkosminis = true;
  chkosagency = true;
  chkostitle = true;
  chkosdes = true;
  chkGlobValue = 'gov.my';
  currTab: any;

  locUnchecked: any = 0;
  osUnchecked: any = 0;

  dLocTopic: boolean = false;
  dLocSubtopic: boolean = false;
  dLocTitle: boolean = false;
  dLocDesc: boolean = false;

  dOsMministry: boolean = false;
  dOsAgency: boolean = false;
  dOsTopic: boolean = false;
  dOsDesc: boolean = false;
  suggestions: any = [];


  // CONTENT FILTER FIELDS

  // LOCAL SEARCH
  category_topic: String = "category_topic";
  category_sub_topic: String = "category_sub_topic";
  ref_language_id: String = "ref_language_id";

  // private internalUrl: string = 'http://10.1.68.158:9200/gosg/content';
  private internalUrl: string = this.config.urlIntSearch;
  private osUrl: string = this.config.urlOsSearch;
  private globalUrl: string = this.config.urlGlobalSearch;

  // Pagination
  totalElements = 0; noPrevData = true; noNextData = false; pagefrom = 0; pageNumber = 1; totalPages = 0; pagesize = 10;
  millisec = 0;
  showNoData = false;

  curr_data_lang: string = "Bahasa Melayu";

  reff: String;
  urlKeyword: any;

  private subscriptionLang: ISubscription;
  public subscriptionFontType: ISubscription;
  public fontType: string = 'Arial';
  private subscriptionFontSize: ISubscription;
  private urlParams: Subscription;

  public fontSize: any = {
    "sizeS": "14px",
    "sizeM": "19px",
    "sizeL": "23px",
    "no_styles": "0.9em"
  };
  keyWordMapIsEmpty: boolean;
  totalPagesStr: any;

  private searchJSONSubscription:ISubscription;
  private searchJSON: any;
  previousRequests = null;
  tempObj: any;
  notFirstPage: boolean = false;
  fromPagination: boolean = false;
  haveFilterBase: boolean = false;
  disableFilterSubmitBtn: boolean = true;

  constructor(
    private portalService: PortalService,
    public navService: NavService,
    private route: ActivatedRoute,
    private router: Router,
    public sharedService: SharedService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private topnavservice: TopnavService,
    private http: Http,
    @Inject(APP_CONFIG) private config: AppConfig,
    private serchService: SearchService,
    private location: Location
  ) {
    this.subscriptionLang = this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      // this.sharedService.errorHandling(event, (function(){
      const myLang = this.translate.currentLang;
      if (myLang === 'en') {
        this.lang = 'en';
        this.languageId = 1;
        this.mainObj.filters.ref_language_id = "1"
        this.curr_data_lang = "Bahasa Melayu";
        moment.updateLocale('en', {
          months : [
              "January", "February", "March", "April", "May", "June", "July",
              "August", "September", "October", "November", "December"
            ]

        });
      }
      if (myLang === 'ms') {
        this.lang = 'ms';
        this.languageId = 2;
        this.mainObj.filters.ref_language_id = "2"
        this.curr_data_lang = "English";
        moment.updateLocale('ms-my', {
          months : [
              "Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai",
              "Ogos", "September", "Oktober", "November", "Disember"
          ]
      });
      }
      this.contentLangId = this.languageId;

      if (this.topnavservice.flagLang) {
        this.btnFilterReset();
        this.searchByKeyword(this.ser_word);
        console.log('topnavservice.flagLang');
        
      }

      setTimeout(() => {
        this.translate.get('pageTitle.home').subscribe((title: string) => {
          title = title + this.translate.instant('home.menu.search');
          this.sharedService.setTitle(title);
          this.sharedService.loadFontSizeData();
        });
      }, 500);

    });

    this.subscriptionFontSize = this.sharedService.fontSizeData.subscribe((data) => {
      this.fontSize = data;
      $('.mat-tab-label').css('font-size', this.fontSize.sizeS);
      $('.mat-tab-link').css('font-size', this.fontSize.sizeS);
      $('.mat-radio-label-content').css('font-size', this.fontSize.sizeS);
      $('.mat-checkbox-label').css('font-size', this.fontSize.sizeS);
      $('.mat-expansion-panel').css('font-size', this.fontSize.sizeS);
      $('.radio label, .checkbox label').css('font-size', this.fontSize.sizeS);
      $('.font-size-l').css('font-size', this.fontSize.sizeL);
      $('.font-size-m').css('font-size', this.fontSize.sizeM);
      $('.font-size-s').css('font-size', this.fontSize.sizeS);
      $('.mat-select-value-text').css('font-size', this.fontSize.sizeS);

      setTimeout(() => {
        $('.font-size-l').css('font-size', this.fontSize.sizeL);
        $('.font-size-m').css('font-size', this.fontSize.sizeM);
        $('.font-size-s').css('font-size', this.fontSize.sizeS);
        $('.mat-radio-label-content').css('font-size', this.fontSize.sizeS);
        $('.mat-select-value-text').css('font-size', this.fontSize.sizeS);
      }, 600);

      /*setTimeout(()=>{
        $('.mat-radio-label-content').css('font-size', this.fontSize.sizeS);
      }, 3000); */

    });

    this.subscriptionFontType = this.sharedService.fontTypeData.subscribe((data) => {
      this.fontType = data;
      $('.mat-button-wrapper').css('font-family', this.fontType);
      $('.mat-tab-label').css('font-family', this.fontType);
      $('.mat-tab-link').css('font-family', this.fontType);
      $('.mat-input-wrapper').css('font-family', this.fontType);
      $('.mat-radio-label-content').css('font-family', this.fontType);
      $('.mat-checkbox-label').css('font-family', this.fontType);
      $('.mat-expansion-panel').css('font-family', this.fontType);
      $('.mat-select-value-text').css('font-family', this.fontType);

    });

    this.searchJSONSubscription = this.sharedService.searchJSON.subscribe((data)=> {

      if (data && Object.keys(data).length!=0) {
        this.searchJSON = data;
      }

    });

    this.getSearchUrl();
  }

  public local = true;
  public os = false;
  public global = false;

  public keywordType = [
    { id: 1, nameEn: 'Exact word', nameMs: 'Perkataan yang tepat' },
    { id: 2, nameEn: 'All word', nameMs: 'Semua dari perkataan' },
    { id: 3, nameEn: 'Any word', nameMs: 'Mana-mana dari perkataan' }
  ];

  dataGlobe = ['gov.my', 'edu.my', 'org.my', '.my']

  // MAIN OBJ
  public mainObj: any = {
    "size": this.pagesize,
    "from": this.pagefrom,
    "keyword": "",
    "previous": null,
    "flip_data": false,
    "filters": {
      "ref_language_id": this.languageId
    }
  }

  // KEYOWRD MAP
  public keywordMap: any = {
    "fields": null,
    "exact": null,
    "all": null,
    "any": null
  };

  // KEYWORD MAP FIELDS
  public notFields: any = [];
  public locNotFields: any = [
    "content_title",
    "content_description",
    "category_topic",
    "category_sub_topic"
  ];

  public osNotFields: any = [
    "ministry_name",
    "agency_name",
    "title",
    "description"
  ];

  public locFields: any = [
    "content_title",
    "content_description",
    "content_text",
    "content_keywords",
    "parent_category_topic",
    "parent_category_sub_topic",
    "category_topic",
    "category_sub_topic"
  ];

  // LOCAL AGGREGATIONS OBJ
  public locAggregations: any = [
    {
      "name": "histogram",
      "type": "dateHistogram",
      "field": "publish_date",
      "interval": "month",
      "time_zone": "+08:00",
      "minDocCount": 1,
      "size": 100
    },
    {
      "name": "filter_topic.parent_category",
      "type": "filter",
      "field": "parent_category.is_active",
      "filter": {
        "parent_category.is_active": true
      },
      "subAggregation": {
        "name": "active_cat",
        "type": "terms",
        "field": "parent_category.topic.raw",
        "size": "100"
      }
    },
    {
      "name": "filter_sub_topic.category",
      "type": "filter",
      "field": "category.is_active",
      "filter": {
        "category.is_active": true
      },
      "subAggregation": {
        "name": "active_cat",
        "type": "terms",
        "field": "category.topic.raw",
        "size": "100"
      }
    }
  ];

  osFields: any = [
    "ministry_name",
    "agency_name",
    "title",
    "description",
    "keyword"
  ];

  osAggregations: any = [
    {
      "name": "ministryAgg",
      "type": "terms",
      "field": "ministry_name.raw",
      "size": "100"
    },
    {
      "name": "agencyAgg",
      "type": "terms",
      "field": "agency_name.raw",
      "size": "100"
    }
  ];

  // -------------------------------- //

  // FILTERS
  public defaultFiltersObj: any = {
    "ref_language_id": this.languageId
  };

  public rangesEndDateObj: any = {
    "ranges":
    {
      "end_date": [
        {
          "gte": "now/d",
          "time_zone": "+08:00"
        }
      ]
    }
  }

  public agencyDefaultFilterObj: any = {
    "is_active": true,
    "is_document": false,
    "enabled": true
  }

  public refLangObj: any = {
    "ref_language_id": this.languageId
  }

  public lifeEventFiltersObj: any = {
    "parent_category": {
      "is_active": true
    },
    "category": {
      "is_active": true
    }
  }

  ngOnInit() {
    // moment.locale('en');

    if (!this.languageId) {
      if (localStorage.getItem('langID')) {
        this.languageId = localStorage.getItem('langID');
      } else {
        this.languageId = 1;
        this.mainObj.filters.ref_language_id = "1"
        this.curr_data_lang = "Bahasa Melayu";
        // moment().locale('en').format('LLL');
      }
      this.addHighlight(this.ser_word);
    }

    console.log({'moment months': moment.months() });
    

    this.previousRequests = null;
    this.tempObj = null;
    
    this.haveFilterBase = false;
    this.keyWordMapIsEmpty = true;
    this.disableFilterSubmitBtn = true;

    //if(!this.currTab){
    //  this.currTab = parseInt(localStorage.getItem('currSearchTab'));
    //}else{
    localStorage.setItem("currSearchTab", "0");
    this.currTab = 0;
    //}
    // this.reff = document.referrer.split("/")[1];
    this.getSearchUrl();

    this.date = moment();

    this.ser_word = localStorage.getItem('ser_word').replace(/[|]/g, "&").replace(/[_]/g, "%");
    // this.ser_word = this.topnavservice.navKeyword;


    this.urlParams = this.route.queryParams.subscribe((params: Params) => {
      this.urlKeyword = params['key'];
      this.urlKeyword = this.urlKeyword.replace(/[|]/g, "&").replace(/[_]/g, "%");
      
      // console.log({ 'urlKeyword': this.urlKeyword });

    });

    // this.router.navigate(['search'], { queryParams: { key: valkeyword } } );
    let locStrgKword = localStorage.getItem('ser_word');
    let navKword = this.urlKeyword;

    if (navKword != locStrgKword) {
      console.log({ 'onInit navKword': navKword });

      localStorage.setItem('ser_word', this.urlKeyword);
      this.ser_word = this.urlKeyword;
      // this.loading = true;

    } else if (this.ser_word != locStrgKword) {
      console.log({ 'onInit ser_word': this.ser_word });

      this.ser_word = this.urlKeyword;
      localStorage.setItem('ser_word', this.urlKeyword);
      // this.loading = true;

    }

    // if (this.ser_word.length > 0) {
    //   this.searchByKeyword(this.ser_word);
    //   console.log('oninit');
    // }
  }

  ngAfterViewInit() {

    // Get Title and Sent to GA
    this.translate.get('pageTitle.home').subscribe((title: string) => {
      title = title + this.translate.instant('home.menu.search');
      this.sharedService.setTitleAndGtag(title);
    });

    this.sharedService.loadFontSizeData();
    this.sharedService.loadFontTypeData();

  }

  ngOnDestroy() {
    moment.locale('en');
    this.subscriptionLang.unsubscribe();
    this.subscriptionFontSize.unsubscribe();
    this.subscriptionFontType.unsubscribe();
    this.navService.deletePreviousSearch();
  }

  btnSubmit() {

    if(this.pagefrom != 0) {
      this.notFirstPage = true;
    } else {
      this.notFirstPage = false;
    }
    // this.pagefrom = 0;
    this.fromPagination = false;
    this.resetPage();
    this.searchByKeyword(this.ser_word);
  }

  getTheme() {
    return localStorage.getItem('themeColor');
  }

  checkKS(sk) {

    this.sKeyword = sk;

    // console.log({'sKeyword':this.sKeyword});
    // console.log({'inpExcWord':this.inpExcWord});
    

    if (this.sKeyword && this.inpExcWord == '') {
      // this.sharedService.showError();
      this.keyWordMapIsEmpty = true;
    }
    this.chkFilterSubmitBtnStatus();

    this.sharedService.loadFontSizeData();
  }

  checkSC(sc) {

    this.sSpeci = sc;

    //$('.mat-radio-label-content').css('font-size',  this.fontSize.sizeS);

    if (this.sSpeci && this.locUnchecked >= 4 || this.sSpeci && this.osUnchecked >= 4) {
      this.sharedService.showError(this.translate.instant('home.search.min1spec'), '');
    }

  }

  changeCurrDataLang() {
    // this.btnFilterReset();
    // this.contentLangId = this.languageId;
    console.log({'contentLangId':this.contentLangId});
    
    if (this.contentLangId == 1) {
      this.contentLangId = 2;
      this.curr_data_lang = "English";
    } else if (this.contentLangId == 2) {
      this.contentLangId = 1;
      this.curr_data_lang = "Bahasa Melayu";
    }

    if(this.languageId == this.contentLangId) {
      this.mainObj.flip_data = false;
    } else {
      this.mainObj.flip_data = true;
    }
  }

  addFilterAry(ary, resObj, type?) {

    //

    if (ary.length > 0) {

      let res = [];
      ary.forEach(ele => {
        //
        if (ele.name) {
          res.push(ele.name);
        } else {
          res.push(ele);
        }
      });

      if (type == "fields") {

      } else {
        this.mainObj.filters[resObj] = res;
      }
    }
  }

  addSpecFiltr(methodNm, field) {
    let key = field;
    //

    let res_ary = this.mainObj.filters;
    //
    //

    // let inx = jQuery.inArray(field, res_ary);
    if (methodNm === 'add') {
      res_ary[field] = [];
      // res_ary.push(enField);
    } else if (methodNm === 'remove') {
      delete res_ary[field];
      // res_ary.splice(2,2);
      // inx = jQuery.inArray(field, res_ary);
      // res_ary.splice(inx_en,1);
    }
  }

  chkmonpub(eve) {
    this.selMonPubDisp = eve.source.triggerValue.split(',')[0];
    // let d = moment.
  }
  chkauth(eve) {
    this.selAuthDisp = eve.source.triggerValue.split(',')[0];
  }
  chkfiltrtopic(eve) {
    this.selTopicDisp = eve.source.triggerValue.split(',')[0];
  }
  chksubtop(eve) {
    this.selSubTopicDisp = eve.source.triggerValue.split(',')[0];
  }
  chkministry(eve) {
    this.selMinisDisp = eve.source.triggerValue.split(',')[0];
  }
  chkagency(eve) {
    this.selAgencyDisp = eve.source.triggerValue.split(',')[0];
  }

  changeAryVal(objs, type) {

    let aryObj: any;
    let retn = [];

    if (type != 'global') {
      aryObj = {
        name: "",
        val: ""
      };

    } else {
      aryObj = {
        title: "",
        description: "",
        url: "",
        date: ""
      };

    }
    Object.keys(objs).map(function (inx) {
      aryObj = new Object;
      if (type != 'global') {
        aryObj.name = inx;
        aryObj.val = objs[inx];
        aryObj.checked = true;
      } else {
        aryObj.title = objs[inx].title;
        aryObj.description = objs[inx].description;
        aryObj.url = objs[inx].url;
        aryObj.date = objs[inx].date;
        aryObj.checked = true;
      }

      // do something with person
      retn.push(aryObj);
    });
    //
    return retn;
  }

  changeTab(e) {

    let tabInx = e.index;
    this.tabIndex = e.index;

    localStorage.setItem("currSearchTab", e.index);
    this.currTab = localStorage.getItem("currSearchTab");

    let k_word = '';
    k_word = this.ser_word;
    // if (this.ser_word.trim().length > 0) {
    //   k_word = this.ser_word.trim()
    // } else {
    //   k_word = this.router.url.split('=')[1];
    // }
    this.inpExcWord = '';

    if (tabInx === 0) {

      this.intData = [];
      this.locNotFields = [
        "content_title",
        "content_description",
        "category_topic",
        "category_sub_topic"
      ];
      this.btnFilterReset();
      //In Local tab
      this.chktopic = true;
      this.chksubtopic = true;
      this.chktitle = true;
      this.chkdes = true;
      // this.mainObj.keywordMap.fields = this.locFields.slice();

      delete this.mainObj.fields;
      this.mainObj.fields = this.locFields;
      delete this.mainObj.aggregations;
      this.mainObj.aggregations = this.locAggregations;
      delete this.mainObj.aggregations;

      this.resetPage();
      this.searchByKeyword(k_word);
    } else if (tabInx === 1) {

      this.intData = [];
      this.osNotFields = [
        "ministry_name",
        "agency_name",
        "title",
        "description"
      ];
      this.btnFilterReset();
      //In Online Service tab
      this.chkosminis = true;
      this.chkosagency = true;
      this.chkostitle = true;
      this.chkosdes = true;
      // this.mainObj.filters = this.agencyDefaultFilterObj.slice();

      delete this.mainObj.fields;
      this.mainObj.fields = this.osFields;

      delete this.mainObj.aggregations;
      delete this.mainObj.filters.category;
      this.mainObj.aggregations = this.osAggregations;
      //
      //
      // this.mainObj.aggregations = {};
      //

      // jQuery.extend(this.mainObj.filters, this.agencyDefaultFilterObj);
      // this.mainObj.keywordMap.fields = this.osFields.slice();
      this.resetPage();
      this.searchByKeyword(k_word);
    } else if (tabInx === 2) {

      this.intData = [];
      this.totalElements = 0;

      //In Global tab
      this.btnFilterReset();
      this.resetPage();
      this.searchByKeyword(k_word);
    }
    this.sharedService.loadFontSizeData();
  }

  checkCurrObj(objName) {

    let objElem;

    switch (objName) {

      case this.category_topic:
        objElem = this.category_topic
        break;

      case this.category_sub_topic:
        objElem = this.category_sub_topic
        break;

      case this.ref_language_id:
        objElem = this.ref_language_id
        break;

    }

    if (this.mainObj.filters.hasOwnProperty(objElem)) {
      this.addSpecFiltr('remove', objElem);
    } else {
      this.addSpecFiltr('add', objElem);
    }
  }

  keywordSplitter(str) {
    //
    let res: any = [];

    str = str.split(" ");
    str.forEach(el => {
      //
      res.push(el);
    });
    // res = str;
    //
    return res;
  }


  searchByKeyword(valkeyword, opt?) {

    this.loading = true;
    // this.mainObj.flip_data = false;
    // event.preventDefault();
      // console.log({'pre navService.previous':this.navService.previous});
      
      // delete this.mainObj.previous;

    // valkeyword = decodeURI(valkeyword);

    if (valkeyword) { //  && valkeyword.trim().length > 0

      if (valkeyword.match(/script/gi)) { //  || valkeyword.match(/<\/?[^>]+(>|$)/g) || valkeyword.match(/[^a-zA-Z0-9 ]/g)

        // console.log('A: ' + valkeyword);
        this.btnFilterReset();
        this.resetPage();
        this.totalPages = 0;
        this.totalElements = 0;
        this.intData = [];
        this.showNoData = true;
        this.sKeyword = false; //side menu
        this.sSpeci = false; //side menu
        this.sFilter = false; //side menu
        // this.searchByKeyword(valkeyword);
        valkeyword = '';
        this.ser_word = '';
        this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');

        this.loading = false;

      } else {

        if (valkeyword.match(/[a-zA-Z0-9]/g)) {

          //  handle slash for URL
          // valkeyword = valkeyword.replace(/[^a-zA-Z0-9@&()[:space:]\.,'"\/-–]/g, "");
          // console.log('B: ' + valkeyword);

          // if(valkeyword.match(/[\/]/g)) {
          //   alert('match found');
          //   valkeyword = encodeURI(valkeyword);
          // }

          // valkeyword = valkeyword.replace(/\./g, '');

          this.getSearchUrl();

          this.intData = [];
          let arrKeyword: any = [];
          let arrKeywordeySetting: any = [];
          let nullObj = {};
          let payloadObj: Object;

          this.totalElements = 0;
          let num;
          let dataLength = 0;
          let dataUrl = '';

          // CONTENT LANG CHANGE
          if (opt) {
            this.changeCurrDataLang();
          } else {

            if (this.languageId)
              this.mainObj.filters.ref_language_id = this.languageId.toString();
            else
              this.mainObj.filters.ref_language_id = "1";
          }

          if (valkeyword.match(/script/gi)) {
            valkeyword = ''
          }

          this.urlParams = this.route.queryParams.subscribe((params: Params) => {
            this.urlKeyword = params['key'];
            // console.log({ 'urlKeyword': this.urlKeyword });
            this.urlKeyword = this.urlKeyword.replace(/[|]/g, "&");

          });

          if (valkeyword)
            this.router.navigate(['search'], { queryParams: { key: valkeyword } });
          else if (this.urlKeyword)
            this.router.navigate(['search'], { queryParams: { key: this.urlKeyword } });

          let locStrgKword = localStorage.getItem('ser_word');
          let navKword = this.urlKeyword;
          // let navKword = this.router.url.split("=")[1];

          // location.href = './search?key=' + decodeURI(this.urlKeyword);
          // navKword = this.urlKeyword.replace(/[|]/g, "&").replace(/[_]/g, "%"); // HANDLING % SYMBOL



          if (navKword != locStrgKword) {
            // this.btnFilterReset();
            navKword.replace(/[|]/g, "&").replace(/[_]/g, "%"); // HANDLING % SYMBOL
            // console.log({ 'navKword': navKword });

            localStorage.setItem('ser_word', navKword);
            this.loading = true;
            // location.href = './search/'+navKword;
            if (this.tabIndex != 2) {
              // this.mainObj.keyword(navKword));
            }

          } else if (valkeyword != locStrgKword) {
            // valkeyword; // HANDLING % SYMBOL .replace(/[&]/g, "|").replace(/[%]/g, "_")
            // console.log({ 'valkeyword': valkeyword });
            // this.btnFilterReset();
            localStorage.setItem('ser_word', valkeyword);
            this.loading = true;
            // location.href = './search/'+valkeyword;
            if (this.tabIndex != 2) {
              // this.mainObj.keyword(decodeURI(valkeyword));
            }

          }

          // if (localStorage.getItem('ser_word').length === 0) {
          //   localStorage.setItem('ser_word', valkeyword);
          // }

          if (this.tabIndex == 0 || this.tabIndex == 1) {
            this.mainObj.keyword = valkeyword.replace(/[|]/g, "&").replace(/[_]/g, "%");
            
            // PAGINATION WITH FILTERING CONTROL
            // console.log({ 'notFirstPage': this.notFirstPage });
            // console.log({ 'fromPagination': this.fromPagination });

            // if(this.notFirstPage && !this.fromPagination) {
              // this.mainObj.from = 0;
            // } else {
              // console.log({ 'pagefrom': this.pagefrom });
              this.mainObj.from = this.pagefrom;
            // }

            this.mainObj.size = this.pagesize;

          }

          // KEYWORD MAP AREA
          if(!opt) {
            let tempKWMap = null;

            if (this.tabIndex == 0)
              this.keywordMap.fields = this.locFields;
            else if (this.tabIndex == 1)
              this.keywordMap.fields = this.osFields;

            // arrKeyword = this.keywordSplitter(this.ser_word)

            if (this.chkKeyValue == "1" && this.inpExcWord) {

              // arrKeywordeySetting = this.keywordSplitter(this.inpExcWord)
              this.keywordMap.exact = [valkeyword];
              this.keywordMap.notExact = [this.inpExcWord];

              delete this.keywordMap.all;
              delete this.keywordMap.any;

              this.mainObj.keywordMap = this.keywordMap;
            } else if (this.chkKeyValue == "2" && this.inpExcWord) {
              // arrKeywordeySetting = this.keywordSplitter(this.inpExcWord);
              this.keywordMap.all = [valkeyword];
              this.keywordMap.notExact = [this.inpExcWord];
              // this.keywordMap.not = arrKeywordeySetting;
              delete this.keywordMap.exact;
              delete this.keywordMap.any;
              //
              this.mainObj.keywordMap = this.keywordMap;
            } else if (this.chkKeyValue == "3" && this.inpExcWord) {
              // arrKeywordeySetting = this.keywordSplitter(this.inpExcWord)
              this.keywordMap.any = [valkeyword];
              this.keywordMap.notExact = [this.inpExcWord];
              delete this.keywordMap.all;
              delete this.keywordMap.exact;
              //
              this.mainObj.keywordMap = this.keywordMap;
            } else if(!this.inpExcWord && this.keywordMap.notExact) {
              console.log('notExact exist');
            } else {
              console.log('no filters');
              
              this.keywordMap.exact = [valkeyword];
              delete this.keywordMap.any;
              delete this.keywordMap.notExact;
              delete this.keywordMap.all;
            }

            if (this.inpExcWord == this.ser_word)
              delete this.keywordMap.notFields;

          }
          // KEYWORD MAP AREA END

          if (this.tabIndex === 0) { // LOCAL SEARCH

            dataUrl = this.internalUrl;

            if(!opt){
            
              delete this.mainObj.aggregations;

              this.mainObj.aggregations = this.locAggregations;

              // Search Spec
              if (this.mainObj.keywordMap && this.inpExcWord && this.notFields.length != 4)
                this.mainObj.keywordMap.notFields = this.notFields;

              // Filter
              // if(this.sKeyword && this.sSpeci && this.sFilter) {
                if ((this.valTopic && this.valTopic.length >= 1) && this.category_topic) {
                  this.checkCurrObj(this.category_topic);
                  this.addFilterAry(this.valTopic, this.category_topic);
                }

                if ((this.valSubTopic && this.valSubTopic.length >= 1) && this.category_sub_topic) {
                  this.checkCurrObj(this.category_sub_topic);
                  this.addFilterAry(this.valSubTopic, this.category_sub_topic);
                }

                // Filter - Month Filter
                if (this.valMonPub) {
                  if (this.valMonPub.length > 0) {
                    let article_insert_date = [];
                    let selmon = this.valMonPub;
                    selmon.forEach(ele => {
                      let mFrom = moment(ele).format('YYYY-MM-DD');
                      let addDays = moment(ele).add(30, 'days');
                      let mTo = moment(addDays.toDate()).format('YYYY-MM-DD');
                      let objloc = {
                        'gte': mFrom,
                        'lte': mTo,
                        "time_zone": "+08:00"
                      }
                      article_insert_date.push(objloc);
                    });
                    if ($.inArray('ranges', Object.keys(this.mainObj.filters)) >= 0) {
                      // If the range filter exist already
                      this.mainObj.filters["ranges"]["publish_date"] = article_insert_date;
                    } else {
                      let range = {
                        'ranges': {
                          'publish_date': []
                        }
                      }
                      range.ranges.publish_date = article_insert_date;
                      jQuery.extend(this.mainObj.filters, range);
                    }
                  }
                }

                jQuery.extend(this.mainObj.filters, this.lifeEventFiltersObj);
              // }
            }

              // NESTED SEARCH
              let prvNvNSrch = this.navService.getPreviousSearch();
              let prvNvNSrchWrd = null;
              let prvNvNSrchTotal = null;
              // console.log({'prvNvNSrch':prvNvNSrch}); 

              if(!opt && prvNvNSrch != null) {

                prvNvNSrchWrd = JSON.parse(this.navService.getPreviousSearch());

                if(prvNvNSrchWrd != null) {
                
                  prvNvNSrchTotal = prvNvNSrchWrd.from;
                  prvNvNSrchWrd = prvNvNSrchWrd.keyword;
                  // console.log({'prvNvNSrchWrd':prvNvNSrchWrd}); 
                  // console.log({'prvNvNSrchTotal':prvNvNSrchTotal}); 

                  if(prvNvNSrchWrd == this.ser_word && this.fromPagination == false) {
                    this.mainObj.previous = JSON.parse(this.navService.getPreviousSearch());
                    if(prvNvNSrchTotal != 0) {
                      this.mainObj.from = 0;
                      this.mainObj.previous.from = 0;

                      // console.log({'mainObj.previous':this.mainObj.previous}); 
                    }
                  } 
                  // else if(prvNvNSrchWrd == this.ser_word && this.fromPagination == true) {
                  //   this.mainObj.previous = null;
                  // }
                }
              }

              if(!opt)
                this.navService.setPreviousSearch(JSON.stringify(this.mainObj));

              // console.log({'mainObj previous':this.mainObj.previous}); 
              // NESTED SEARCH

            payloadObj = this.mainObj;

          } else if (this.tabIndex === 1) { // ONLINE SERVICE SEARCH

            dataUrl = this.osUrl;
            
              delete this.mainObj.aggregations;
              delete this.mainObj.filters.parent_category;
              delete this.mainObj.filters.category;
              this.mainObj.aggregations = this.osAggregations;

              // if(env == 'localhost')
              // console.log({'dataUrl':dataUrl}); 
              // else
              // dataUrl = localURL+'agency';

              // Search Spec
              if (this.mainObj.keywordMap && this.inpExcWord && this.notFields.length != 4)
                this.mainObj.keywordMap.notFields = this.notFields;
              // else
              //   delete this.mainObj.keywordMap.notFields;


              // if(this.sKeyword && this.sSpeci && this.sFilter) {
                // Ministry Filter
                if (this.valMinistry) {
                  this.addFilterAry(this.valMinistry, 'ministry_name');
                }
                // Agency Filter
                if (this.valAgency) {
                  this.addFilterAry(this.valAgency, 'agency_name');
                }

                // Filter - Month Filter
                if (this.valMonPub) {
                  if (this.valMonPub.length > 0) {
                    let article_insert_date = [];
                    let selmon = this.valMonPub;
                    selmon.forEach(ele => {
                      let mFrom = moment(ele).format('YYYY-MM-DD');
                      let addDays = moment(ele).add(30, 'days');
                      let mTo = moment(addDays.toDate()).format('YYYY-MM-DD');
                      let objloc = {
                        'gte': mFrom,
                        'lte': mTo,
                        "time_zone": "+08:00"
                      }
                      article_insert_date.push(objloc);
                    });
                    if ($.inArray('ranges', Object.keys(this.mainObj.filters)) >= 0) {
                      // If the range filter exist already
                      this.mainObj.filters["ranges"]["publish_date"] = article_insert_date;
                    } else {
                      let range = {
                        'ranges': {
                          'publish_date': []
                        }
                      }
                      range.ranges.publish_date = article_insert_date;
                      jQuery.extend(this.mainObj.filters, range);
                    }
                  }
                }
              // }

              // NESTED SEARCH
              let prvNvNSrch = this.navService.getPreviousSearch();
              let prvNvNSrchWrd = null;
              // console.log({'prvNvNSrch':prvNvNSrch}); 

              if(!opt && prvNvNSrch != null) {

                prvNvNSrchWrd = JSON.parse(this.navService.getPreviousSearch());
                if(prvNvNSrchWrd != null) {
                  prvNvNSrchWrd = prvNvNSrchWrd.keyword;
                  console.log({'prvNvNSrchWrd':prvNvNSrchWrd}); 

                  if(prvNvNSrchWrd == this.ser_word) {
                    this.mainObj.previous = JSON.parse(this.navService.getPreviousSearch());
                  } else {
                    this.mainObj.previous = null;
                    delete this.mainObj.keywordMap;
                    // delete this.mainObj.filters.parent_category;
                    // delete this.mainObj.filters.category;
                  }
                }
              }

              if(!opt)
                this.navService.setPreviousSearch(JSON.stringify(this.mainObj));
              // NESTED SEARCH

            payloadObj = this.mainObj;
            
          } else if (this.tabIndex == 2) { // GLOBAL SEARCH
            // malaysia%2Bsite%3Agov.my
            dataUrl = this.globalUrl + "?keywords=" + decodeURIComponent(this.ser_word) + "%2Bsite%3A" + this.chkGlobValue + "&pagecount=" + this.pageNumber;

            payloadObj = nullObj;
          }

          if (this.tabIndex === 0 || this.tabIndex === 1) { // INTERNAL & ONLINE SERVICES SEARCH
            // console.log({'dataUrl':dataUrl}); 

            return this.http.post(dataUrl, payloadObj)
              .map(res => res.json())
              .subscribe(rData => {

                window.scrollTo(0, 0);

                // console.log({'payloadObj':payloadObj}); 
                // num = 0;
                // dataLength = 0;
                // this.pageNumber = 0;

                // this.navService.previous = payloadObj;
    
                // console.log({'new navService previous':this.navService.previous}); 

                // console.log({'pageNumber':this.pageNumber});

                if (rData.stats.hits) {
                  this.totalElements = rData.stats.hits;
                  num = (rData.stats.hits) / (this.pagesize);
                }
                this.millisec = rData.stats.tookMillis;

                if(payloadObj['flip_data'] == false && (payloadObj['previous'] != null || payloadObj['previous'] == null)) {
                
                  this.intData = rData.data;
                  dataLength = rData.data.length;
                  // console.log({'num':num});
                  
                } else if(payloadObj['flip_data'] == true) {
                  this.intData = rData.flip_data;
                  dataLength = rData.flip_data.length;
                }

                this.intData.forEach(ele => {
                  // console.log({'raw':ele.publish_date});

                  if (ele.publish_date) {
                    // console.log({'original':ele.publish_date});
                    ele.publish_date = moment(this.isoDateConverter(ele.publish_date)).add(8, 'hours').format('DD-MM-YYYY');

                    // console.log({'modded':ele.publish_date});
                  }

                });
                // console.log({'intData':this.intData});

                if (dataLength > 0) {

                  this.selMonPubDisp = '';
                  this.selAuthDisp = '';
                  this.selTopicDisp = '';
                  this.selSubTopicDisp = '';
                  this.selMinisDisp = '';
                  this.selAgencyDisp = '';
                  this.ddauthor = [];
                  this.ddtopics = [];
                  this.ddmonthPub = [];
                  this.ddsubTopics = [];
                  this.ddministry = [];
                  this.ddagency = [];
  
                  this.valMonPub = [];
                  this.valAuthor = [];
                  this.valTopic = [];
                  this.valSubTopic = [];
                  this.valMinistry = [];
                  this.valAgency = [];

                  // let mLoc = 'en';
                  
                  // if(this.languageId == 1)
                  //   mLoc = 'en';
                  // else
                  //   mLoc = 'ms-my';

                  if (this.tabIndex == 0) { // LOCAL
                    let itemObj: any = {};

                    if (rData.aggregations.histogram) {
                      rData.aggregations['histogram'].forEach(item => {
                        
                        item = this.changeAryVal(item, 'generic');
                        // console.log({'item name': moment(item[0].name).locale(mLoc).format('MMMM YYYY') });

                        itemObj = { "name": moment(item[0].name).format('MMMM YYYY'), "val": item[0].val };
                        // itemObj = { "name": moment(item[0].name).locale(mLoc).format('MMMM YYYY'), "pushVal": item[0].name, "val": item[0].val }
                        this.ddmonthPub.push(itemObj);
                      });
                      // this.addCheckedProperty(this.ddmonthPub);
                    }

                    //
                    rData.aggregations['filter_topic.parent_category'][0].active_cat.forEach(item => {
                      item = this.changeAryVal(item, 'generic')
                      itemObj = { "name": item[0].name, "val": item[0].val };
                      this.ddtopics.push(itemObj);
                    });
                    // this.addCheckedProperty(this.ddtopics);

                    rData.aggregations['filter_sub_topic.category'][0].active_cat.forEach(item => {
                      item = this.changeAryVal(item, 'generic')
                      itemObj = { "name": item[0].name, "val": item[0].val }
                      this.ddsubTopics.push(itemObj)
                    });
                    // this.addCheckedProperty(this.ddsubTopics);

                  } else if (this.tabIndex == 1) { // ONLINE SERVICES
                    let ministry: any = {};
                    let agency: any = {};

                    rData.aggregations.ministryAgg.forEach(item => {
                      item = this.changeAryVal(item, 'generic');
                      //
                      ministry = { "name": item[0].name, "val": item[0].val }
                      this.ddministry.push(ministry);
                    });
                    // this.addCheckedProperty(this.ddministry);

                    rData.aggregations.agencyAgg.forEach(item => {
                      item = this.changeAryVal(item, 'generic');
                      //
                      agency = { "name": item[0].name, "val": item[0].val }
                      this.ddagency.push(agency);
                    });
                    // this.addCheckedProperty(this.ddagency);

                  }

                  // PAGINATION //

                  // if(this.notFirstPage && !this.fromPagination) {
                  //   this.totalPages = 0;
                  // }
                  //  else {
                  //   this.totalPages = 0;
                  // }

                  if (this.totalElements % this.pagesize > 0) {
                    this.totalPages = Math.floor(num) + 1;
                  } else {
                    this.totalPages = num;
                  }

                  if (this.totalPages > 0) {
                    this.noNextData = this.pageNumber === this.totalPages;
                  } else {
                    this.noNextData = true;
                  }

                  this.totalPagesStr = this.totalPages;
                  if (this.totalPages && this.totalPages > 999) {
                    // this.totalPages = num;
                      this.totalPagesStr = this.totalPages.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                  }

                  // console.log({'totalPages':this.totalPages});
                  // console.log({'totalPagesStr':this.totalPagesStr});

                  // PAGINATION //

                  this.showNoData = false;

                } else {
                  this.showNoData = true;
                  this.sKeyword = false; //side menu
                  this.sSpeci = false; //side menu
                  this.sFilter = false; //side menu
                }
                this.loading = false;
                rData = null;

                if (this.inpExcWord) {
                  this.inpExcWord = '';
                  this.keyWordMapIsEmpty = true;
                }

                this.disableFilterSubmitBtn = true;
                window.scrollTo(0, 0);
                this.sharedService.loadFontSizeData();
                this.suggestions = [];

              },
                error => {
    
                  window.scrollTo(0, 0);
                  this.loading = false;
                  this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                });

          } else { // GLOBAL SEARCH

            let tStart, tEnd;

            // tStart = console.time('global search for: '+ this.ser_word)
            tStart = new Date().getTime();

            return this.http.get(dataUrl, payloadObj)
              .map(res => res.json())
              .subscribe(rData => {
                // console.log({'rData global':rData});

                // DEBUG MODE ONLY
                if (!rData.data) {
                  this.showNoData = true;
                  
                  this.loading = false;
                  // this.sharedService.showError(this.translate.instant('common.err.servicedown'), '');
                  // // tEnd = console.timeEnd('global search for: '+ this.ser_word);
                  // tEnd = new Date().getTime() - tStart;
                  // console.log(tEnd);
                } else {
                  // console.log({'rData global':rData});
                  this.totalElements = parseInt(rData.data.countinfo);
                  num = (this.totalElements) / (this.pagesize);
                  delete rData.data.countinfo;
                  dataLength = Object.keys(rData.data).length;

                  // console.log({'dataLength':dataLength});
                  // console.log({'global totalElements':this.totalElements});
                  // console.log({'num':num});

                  this.intData = this.changeAryVal(rData.data, 'global')

                  this.selMonPubDisp = '';
                  this.selAuthDisp = '';
                  this.selTopicDisp = '';
                  this.selSubTopicDisp = '';
                  this.selMinisDisp = '';
                  this.selAgencyDisp = '';
                  this.ddauthor = [];
                  this.ddtopics = [];
                  this.ddmonthPub = [];
                  this.ddsubTopics = [];
                  this.ddministry = [];
                  this.ddagency = [];

                  this.valMonPub = [];
                  this.valAuthor = [];
                  this.valTopic = [];
                  this.valSubTopic = [];
                  this.valMinistry = [];
                  this.valAgency = [];

                  if (dataLength > 0) {

                    if (this.totalElements % this.pagesize > 0) {
                      this.totalPages = Math.floor(num) + 1;
                    } else {
                      this.totalPages = num;
                    }
                    // console.log({'totalPages':this.totalPages});
                    

                    if (this.totalPages > 0) {
                      this.noNextData = this.pageNumber === this.totalPages;
                    } else {
                      this.noNextData = true;
                    }

                    if (num && num > 999){
                      this.totalPages = num;
                      this.totalPagesStr = num;
                      
                      if(num.length > 3)
                        this.totalPagesStr = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                    }

                    // this.totalElements.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")

                    //   this.serchService.searchResData = rData.data;
                    this.showNoData = false;

                  } else {
                    this.showNoData = true;
                    this.sKeyword = false; //side menu
                    this.sSpeci = false; //side menu
                    this.sFilter = false; //side menu
                  }
                  this.loading = false;
                  rData = null;
                  // tEnd = console.timeEnd('global search for: '+ this.ser_word);
                  tEnd = new Date().getTime() - tStart;
                  console.log(Math.round(tEnd))
                  this.millisec = tEnd;
                }
    
                window.scrollTo(0, 0);
              },
                error => {
                  console.log('global error');
                  this.intData = [];
                  this.showNoData = true;
    
                  window.scrollTo(0, 0);
                  console.log({'error':error});
                  
                  this.loading = false;
                  // this.sharedService.showError(this.translate.instant('common.err.failtoload'), '');
                  // tEnd = console.timeEnd('global search for: '+ this.ser_word);
                  tEnd = new Date().getTime() - tStart;
                  console.log(tEnd)
    
                  window.scrollTo(0, 0);
                });
    

          }

        } else {
          console.log('symbols only not valid');
          // console.log('invalid');
          // console.log(valkeyword);
          this.btnFilterReset();
          this.resetPage();
          this.totalPages = 0;
          this.totalElements = 0;
          this.intData = [];
          this.showNoData = true;
          this.sKeyword = false; //side menu
          this.sSpeci = false; //side menu
          this.sFilter = false; //side menu
          // this.searchByKeyword(valkeyword);
          valkeyword = '';
          this.ser_word = '';
          this.sharedService.showError(this.translate.instant('common.msg.validsearchKeyword'), '');
          this.loading = false;
        }
      }

    } else {
      // console.log(valkeyword);
      this.btnFilterReset();
      this.resetPage();
      this.totalPages = 0;
      this.totalElements = 0;
      this.intData = [];
      this.showNoData = true;
      this.sKeyword = false; //side menu
      this.sSpeci = false; //side menu
      this.sFilter = false; //side menu
      // this.searchByKeyword(valkeyword);
      valkeyword = '';
      this.ser_word = '';
      this.sharedService.showError(this.translate.instant('common.msg.searchKeyword'), '');
      this.loading = false;
    }

    // if (this.inpExcWord !== '') {
      // this.inpExcWord = '';
    // }
  }

  isoDateConverter(isod) {
    isod = isod.replace(/0Z/gi, '');

    return isod;
  }

  getSearchUrl() {

    return this.http.get(this.config.urlGlobalSearch)
      .map(res => res.json())
      .subscribe(data => {
        this.globalUrl = data.resource.searchUrl;
      });
  }

  changeGlob(eve, val) {
    this.chkGlobValue = val;
    this.searchByKeyword(this.ser_word);
    //
  }

  chkKeyword(e?, id?) {
    // console.log({'kword val':e.target.value});
    // console.log({'kword val length':e.target.value.length});
    // this.inpExcWord = '';
    // this.sharedService.showSuccess(id);
    // let kwordlen = e.target.value.length;

    if(this.inpExcWord.length != 0)
      this.keyWordMapIsEmpty = false;
    else
      this.keyWordMapIsEmpty = true;

    this.chkFilterSubmitBtnStatus();

  }

  clone(obj) {
    if (null == obj || "object" != typeof obj) return obj;
    var copy = obj.constructor();
    for (var attr in obj) {
        if (obj.hasOwnProperty(attr)) copy[attr] = obj[attr];
    }
    return copy;
  }


  chkSpeci(e, type, elemName) {
    //
    //

    switch (type) {

      case "category_topic":
        this.chktopic = e.checked
        if (e.checked == false) {
          this.selTopicDisp = "";
          this.valTopic = [];
          this.locUnchecked = this.locUnchecked + 1;
        } else if (e.checked == true) {
          this.locUnchecked = this.locUnchecked - 1;
        }
        break;

      case "category_sub_topic":
        this.chksubtopic = e.checked
        if (e.checked == false) {
          this.selSubTopicDisp = "";
          this.valSubTopic = [];
          this.locUnchecked = this.locUnchecked + 1;
        } else if (e.checked == true) {
          this.locUnchecked = this.locUnchecked - 1;
        }

        break;

      case "content_title":
        this.chktitle = e.checked
        if (e.checked == false) {
          this.locUnchecked = this.locUnchecked + 1;
        } else if (e.checked == true) {
          this.locUnchecked = this.locUnchecked - 1;
        }

        break;

      case "content_description":
        this.chkdes = e.checked
        if (e.checked == false) {
          this.locUnchecked = this.locUnchecked + 1;
        } else if (e.checked == true) {
          this.locUnchecked = this.locUnchecked - 1;
        }

        break;

      case "title":
        this.chkostitle = e.checked
        if (e.checked == false) {
          this.osUnchecked = this.osUnchecked + 1;
        } else if (e.checked == true) {
          this.osUnchecked = this.osUnchecked - 1;
        }

        break;

      case "description":
        this.chkosdes = e.checked
        if (e.checked == false) {
          this.osUnchecked = this.osUnchecked + 1;
        } else if (e.checked == true) {
          this.osUnchecked = this.osUnchecked - 1;
        }

        break;

      case "ministry_name":
        this.chkosminis = e.checked
        if (e.checked == false) {
          this.selMinisDisp = "";
          this.valMinistry = [];
          this.osUnchecked = this.osUnchecked + 1;
        } else if (e.checked == true) {
          this.osUnchecked = this.osUnchecked - 1;
        }

        break;

      case "agency_name":
        this.chkosagency = e.checked
        if (e.checked == false) {
          this.selAgencyDisp = "";
          this.valAgency = [];
          this.osUnchecked = this.osUnchecked + 1;
        } else if (e.checked == true) {
          this.osUnchecked = this.osUnchecked - 1;
        }

        break;

      case "citizen":
        this.chkcitizen = e.checked
        break;

      case "noncitizen":
        this.chknoncitizen = e.checked
        break;

    }
    this.chkSpec(type, e.source);

    if (this.locUnchecked >= 4 || this.osUnchecked >= 4) {
      this.sharedService.showError(this.translate.instant('home.search.min1spec'), '');
    }
    this.chkFilterSubmitBtnStatus();
  }

  chkSpec(type, src) {
    let found, foundIndex, tot;

    if (this.tabIndex == 0) {
      this.notFields = this.locNotFields;
      found = this.notFields.find(k => k == type);
      foundIndex = this.notFields.findIndex(k => k == type);
      tot = this.notFields.length - 1;

      if (!found) {
        this.notFields.push(type);
      } else {
        if (this.notFields.length != 0)
          this.notFields.splice(foundIndex, 1);
      }

    } else if (this.tabIndex == 1) {
      this.notFields = this.osNotFields;
      found = this.notFields.find(k => k == type);
      foundIndex = this.notFields.findIndex(k => k == type);
      tot = this.notFields.length - 1;

      if (!found) {
        this.notFields.push(type);
      } else {
        if (this.notFields.length != 0)
          this.notFields.splice(foundIndex, 1);
      }
    }

    console.log({ "spec": this.notFields })

    this.chkFilterSubmitBtnStatus();
    // if(tot != 1) {
    //   this.chktopic = true;
    //   this.chksubtopic = true;
    //   this.chktitle = true;
    //   this.chkdes = true;
    // }

  }

  showdatafn(val) {
    this.dataEach = val;
    this.serchService.searchResData = val;
  }

  paginatorL1(firstPage) {
    this.pageNumber = firstPage;
    this.pagefrom = this.pagefrom - this.pagesize;
    this.noPrevData = true;
    this.notFirstPage = false;
    this.fromPagination = true;
    this.searchByKeyword(this.ser_word);
    this.sharedService.loadFontSizeData();
  }

  paginatorL() {
    this.pageNumber = this.pageNumber - 1;
    this.pagefrom = this.pagefrom - this.pagesize;
    this.noPrevData = this.pagefrom === 0;
    this.notFirstPage = true;
    this.fromPagination = true;
    this.searchByKeyword(this.ser_word);
    this.sharedService.loadFontSizeData();
  }

  paginatorR() {
    this.pageNumber = this.pageNumber + 1;
    this.pagefrom = this.pagefrom + this.pagesize;
    this.noNextData = (this.pagefrom + this.pagesize) < this.totalElements ? false : true;
    this.noPrevData = false;
    this.notFirstPage = true;
    this.fromPagination = true;
    this.searchByKeyword(this.ser_word);
    this.sharedService.loadFontSizeData();
  }

  paginatorRL(lastPage) {
    this.pageNumber = lastPage;
    this.pagefrom = (this.totalPages * 10) - 10;
    // this.pagefrom = this.pagefrom + this.pagesize;
    this.noNextData = true;
    this.noPrevData = false;
    this.notFirstPage = true;
    this.fromPagination = true;
    this.searchByKeyword(this.ser_word);
    this.sharedService.loadFontSizeData();
  }

  pageChange(evt) {
    //
    this.resetPage();
    this.pagesize = evt.value;
    this.searchByKeyword(this.ser_word);
  }

  resetPage() {
    $('.hover_bkgr_fricc').css({ 'display': 'none' });
    this.navService.isSearchSuggestionList = false;
    this.navService.ispopUpShow = false;
    this.pageNumber = 1;
    this.pagefrom = 0;
    this.noNextData = false;
    this.noPrevData = true;
    this.pagesize = 10;
  }

  btnFilterReset() {

    this.pagefrom = 0;
    this.locUnchecked = 0;
    this.osUnchecked = 0;

    this.inpExcWord = '';
    this.chktopic = true;
    this.chksubtopic = true;
    this.chktitle = true;
    this.chkdes = true;
    this.chkosminis = true;
    this.chkosagency = true;
    this.chkostitle = true;
    this.chkosdes = true;
    this.locNotFields = [
      "content_title",
      "content_description",
      "category_topic",
      "category_sub_topic"
    ];
    this.osNotFields = [
      "ministry_name",
      "agency_name",
      "title",
      "description"
    ];

    this.valMonPub = [];
    this.valAuthor = [];
    this.valTopic = [];
    this.valSubTopic = [];

    this.valMinistry = [];
    this.valAgency = [];

    this.notFields = [];

    if (this.tabIndex == 0) {

      if (this.mainObj.filters.category_sub_topic)
        delete this.mainObj.filters.category_sub_topic;

      if (this.mainObj.filters.category_topic)
        delete this.mainObj.filters.category_topic;

      if (this.mainObj.filters.agency_name)
        delete this.mainObj.filters.agency_name;

      if (this.mainObj.filters.ministry_name)
        delete this.mainObj.filters.ministry_name;

      delete this.mainObj.filters.ranges;

      this.mainObj.filters = this.defaultFiltersObj;
      jQuery.extend(this.mainObj.filters, this.lifeEventFiltersObj);

      this.chkcitizen = false;
      this.chknoncitizen = false;

    } else if (this.tabIndex == 1) {

      if (this.mainObj.filters.category_sub_topic)
        delete this.mainObj.filters.category_sub_topic;

      if (this.mainObj.filters.category_topic)
        delete this.mainObj.filters.category_topic;

      if (this.mainObj.filters.ranges)
        delete this.mainObj.filters.ranges;

      delete this.mainObj.filters.agency_name;
      delete this.mainObj.filters.ministry_name;
      delete this.mainObj.filters.enabled;
      delete this.mainObj.filters.is_document;
      delete this.mainObj.aggregations;

      this.mainObj.filters = this.defaultFiltersObj;
      this.mainObj.aggregations = this.osAggregations;

    }
    // delete this.mainObj.filters;
    // this.mainObj.filters = {};

    if (this.mainObj.keywordMap) {
      console.log('got keywordMap to reset');
      
      delete this.mainObj.keywordMap.notExact;
      delete this.mainObj.keywordMap.notFields;
      delete this.mainObj.keywordMap;
    }

    this.chkKeyword();

    this.navService.deletePreviousSearch();
    this.mainObj.previous = null;
    this.navService.setPreviousSearch(null);
    window.scrollTo(0, 0);

  }

  chkFilterSubmitBtnStatus() {

    this.chkFilterBase();

    // console.log({'sKeyword':this.sKeyword});
    // console.log({'inpExcWord':this.inpExcWord});
    // console.log({'inpExcWord.length':this.inpExcWord.length});
    // console.log('=====');
    // console.log({'sSpeci':this.sSpeci});
    // console.log({'locUnchecked':this.locUnchecked});
    // console.log({'osUnchecked':this.osUnchecked});
    // console.log('=====');
    // console.log({'sFilter':this.sFilter});
    // console.log({'haveFilterBase':this.haveFilterBase});
    // console.log('=====');
    // console.log('=====');

    if(this.sKeyword) { // expand
      if(this.inpExcWord) { // have word
        if(this.inpExcWord.length >= 3) { // same or more characters

          this.disableFilterSubmitBtn = false;

          if(!this.sSpeci) { // no specs
            this.disableFilterSubmitBtn = true;

            // if(this.locUnchecked && this.locUnchecked < 4) { // local
            //   this.disableFilterSubmitBtn = false;
            // } 
            
            // if(this.locUnchecked && this.locUnchecked == 4) {
            //   this.disableFilterSubmitBtn = true;
            // }
            
            // if(this.osUnchecked && this.osUnchecked == 0) { // os
            //   this.disableFilterSubmitBtn = false;
            // } 
            
            // if(this.osUnchecked && this.osUnchecked == 4) {
            //   this.disableFilterSubmitBtn = true;
            // }

          } else if(this.sSpeci) { // have specs

            if(this.locUnchecked && this.locUnchecked < 4) { // local
              this.disableFilterSubmitBtn = false;
            } 
            
            if(this.locUnchecked && this.locUnchecked == 4) {
              this.disableFilterSubmitBtn = true;
            }
            
            if(this.osUnchecked && this.osUnchecked == 0) { // os
              this.disableFilterSubmitBtn = false;
            } 
            
            if(this.osUnchecked && this.osUnchecked == 4) {
              this.disableFilterSubmitBtn = true;
            }

          }
        
          if(this.sSpeci && this.sFilter) { // expand
            this.disableFilterSubmitBtn = true;
            
            if(this.haveFilterBase) { // have filters
              this.disableFilterSubmitBtn = false;
            }

            if(this.locUnchecked && this.locUnchecked < 4) { // local
              this.disableFilterSubmitBtn = false;
            } 
            
            if(this.locUnchecked && this.locUnchecked == 4) {
              this.disableFilterSubmitBtn = true;
            }
            
            if(this.osUnchecked && this.osUnchecked == 0) { // os
              this.disableFilterSubmitBtn = false;
            } 
            
            if(this.osUnchecked && this.osUnchecked == 4) {
              this.disableFilterSubmitBtn = true;
            }
  
          } else if(!this.sSpeci && this.sFilter) {
            this.disableFilterSubmitBtn = true;
          }
          
        } else if(this.inpExcWord.length < 3) {
          this.disableFilterSubmitBtn = true;
        
          if(this.sFilter) { // expand
            this.disableFilterSubmitBtn = true;
            
            if(this.haveFilterBase) { // have filters
              this.disableFilterSubmitBtn = true;
            }
  
          }
        }
          
      } else {
        this.disableFilterSubmitBtn = true;
      
        if(this.sFilter) { // expand
          this.disableFilterSubmitBtn = true;
          
          if(this.haveFilterBase) { // have filters
            this.disableFilterSubmitBtn = true;
          }

        }
      }
        
    }
    
    if(!this.sKeyword && this.sSpeci && !this.sFilter) {
      this.disableFilterSubmitBtn = true;
    }
        
    if(!this.sKeyword && !this.sSpeci && this.sFilter) { // filters only
      console.log('filters only');

      this.disableFilterSubmitBtn = true;
      
      if(this.haveFilterBase) { // have filter values
        // if(this.sKeyword || this.sSpeci) {
        //   this.disableFilterSubmitBtn = true;
        // } else 
          this.disableFilterSubmitBtn = false;
      }

    } else if(!this.sKeyword && this.sSpeci && this.sFilter) { // speci & filters
      this.disableFilterSubmitBtn = true;
    }

    // console.log({'disableFilterSubmitBtn':this.disableFilterSubmitBtn});
  }

  chkFilterBase() {

    // console.log({'valMonPub':this.valMonPub.length});

    if (this.tabIndex == 0) {
      // console.log({'valTopic':this.valTopic.length});
      // console.log({'valSubTopic':this.valSubTopic.length});

      if(this.valTopic.length != 0 || this.valSubTopic.length != 0 || this.valMonPub.length != 0) {
      
        this.haveFilterBase = true;
      } else {
        this.haveFilterBase = false;
      }
    } else if (this.tabIndex == 1) {
      // console.log({'valMinistry':this.valMinistry.length});
      // console.log({'valAgency':this.valAgency.length});

      if(this.valMinistry.length != 0 || this.valAgency.length != 0 || this.valMonPub.length != 0) {
      
        this.haveFilterBase = true;
      } else {
        this.haveFilterBase = false;
      }
    }
     
  }

  valueChangeTopic(model, index, $event) {
    //set the two-way binding here for the specific unit with the event
    model[index].checked = $event.checked;
    this.valTopic = [];
    for (let i in this.ddtopics) {
      if (model[i].checked) {
        this.valTopic.push(model[i].name);
      }
    }
    this.chkFilterSubmitBtnStatus();

  }

  valueChangeSubTopic(model, index, $event) {
    //set the two-way binding here for the specific unit with the event
    model[index].checked = $event.checked;
    this.valSubTopic = [];
    for (let i in this.ddsubTopics) {
      if (model[i].checked) {
        this.valSubTopic.push(model[i].name);
      }
    }
    this.chkFilterSubmitBtnStatus();

  }

  valueChangeMonthPub(model, index, $event) {
    //set the two-way binding here for the specific unit with the event
    model[index].checked = $event.checked;
    this.valMonPub = [];
    for (let i in this.ddmonthPub) {
      if (model[i].checked) {
        this.valMonPub.push(model[i].name);
      }
    }
    this.chkFilterSubmitBtnStatus();
  }

  valueChangeMinistry(model, index, $event) {
    //set the two-way binding here for the specific unit with the event
    model[index].checked = $event.checked;
    this.valMinistry = [];
    for (let i in this.ddministry) {
      if (model[i].checked) {
        this.valMinistry.push(model[i].name); 
      }
    }
    this.chkFilterSubmitBtnStatus();
  }

  valueChangeAgency(model, index, $event) {
    //set the two-way binding here for the specific unit with the event
    model[index].checked = $event.checked;
    this.valAgency = [];
    for (let i in this.ddagency) {
      if (model[i].checked) {
        this.valAgency.push(model[i].name);
      }
    }
    this.chkFilterSubmitBtnStatus();
  }

  addCheckedProperty(model) {
    model.forEach(item => {
      if (!item.hasOwnProperty('checked')) {
        item.checked = true; //change as per your requirement
      }
    });
  }

  closeList(e) {
      // console.log({'event':e});
      // console.log({'className':e.target.className});
      // console.log({'ispopUpShow':this.navService.ispopUpShow});
      // console.log({'isNavSuggestionList':this.navService.isNavSuggestionList});
      // console.log({'isHomeSearchSuggestionList':this.navService.isHomeSearchSuggestionList});
      // console.log({'isSearchSuggestionList':this.navService.isSearchSuggestionList});
      if(e.target.className === "hover_bkgr_fricc" && this.navService.ispopUpShow && (this.navService.isNavSuggestionList || this.navService.isHomeSearchSuggestionList || this.navService.isSearchSuggestionList)) {
          this.navService.ispopUpShow = false;
          this.navService.isNavSuggestionList = false;
          this.navService.isHomeSearchSuggestionList = false;
          this.navService.isSearchSuggestionList = false;
      }
      
      $('.hover_bkgr_fricc').css({ 'display': 'none' });
                    
  }

  suggestionByGoogle(key) {
           
    this.portalService.readPortal('google/api/searchsuggest', '', '', '', 'q='+encodeURIComponent(key)).subscribe(res => {

      this.suggestions = res['suggestion'];
              
      // console.log({'suggestions':this.suggestions});

      if(this.suggestions.length != 0) {
          $('.hover_bkgr_fricc').css({ 'display': 'block' });
          // this.suggestions = this.convert2arr(res['_body']);
          this.addHighlight(key);
          this.navService.isSearchSuggestionList = true;
          this.navService.ispopUpShow = true;
      }

    },
    error => {
        console.log(error);
    });

}

suggestionByAugeo(key, miageourl) {

let url = miageourl;

let keywordBody = {
    "keyword": encodeURIComponent(key)
};


this.portalService.getAutocompleteByUrl(keywordBody, url).subscribe(res => {
    let tempArr: any = [];
    tempArr = res;
    // console.log({'tempArr':tempArr});
    this.suggestions = [];

    if (tempArr['data'].length != 0) {
        tempArr['data'].forEach(el => {
            let dataObj = { 'data': null };
            // console.log({'el':el});
            dataObj.data = el.keyword[0];
            this.suggestions.push(dataObj);
        });
    }
    console.log({ 'suggestions': this.suggestions });

    if (this.suggestions.length != 0) {
        $('.hover_bkgr_fricc').css({ 'display': 'block' });
        // this.suggestions = this.convert2arr(res['_body']);
        this.addHighlight(key);
        this.navService.isSearchSuggestionList = true;
        this.navService.ispopUpShow = true;
    }

},
    error => {
        console.log(error);
    });

}



  getSuggestions(key) {

    this.suggestions = [];

    let suggestSource;
    let miageoUrl;
    if (this.searchJSON && this.searchJSON.active==true) {
      suggestSource =  this.searchJSON.type;
      miageoUrl = this.searchJSON.miaugeourl;
    } else if (this.searchJSON && this.searchJSON.active==false) {
      return;
    } else {
      suggestSource = 'google';
    }

    /*let keywordBody = {
      "keyword":encodeURIComponent(key)
    };*/

    // console.log({'keywordBody':keywordBody});
    
    /*if(environment.production) {*/
      if(key && key.length != 0 && key.length >= 3){
        if (suggestSource == 'google') {
          this.suggestionByGoogle(key);
        } else {
          this.suggestionByAugeo(key, miageoUrl);
        }
          /*// this.http.get(corsURL+'https://suggestqueries.google.com/complete/search?output=toolbar&hl=en&q='+key,{headers}).subscribe(res => {
          this.portalService.readPortal('google/api/searchsuggest', '', '', '', 'q='+encodeURIComponent(key)).subscribe(res => {
          // this.portalService.getAutocompleteList(keywordBody).subscribe(res => {

              this.suggestions = res['suggestion'];
              
              // console.log({'suggestions':this.suggestions});

              if(this.suggestions.length != 0) {
                  $('.hover_bkgr_fricc').css({ 'display': 'block' });
                  // this.suggestions = this.convert2arr(res['_body']);
                  this.addHighlight(key);
                  this.navService.isSearchSuggestionList = true;
                  this.navService.ispopUpShow = true;
              }

          },
          error => {
              console.log(error);
              // this.loading = false;
          //   this.loading = false;
          //   this.commonservice.showError(JSON.parse(error._body).statusDesc, '');
          }); */
        
      } else {
        $('.hover_bkgr_fricc').css({ 'display': 'none' });
        this.navService.isSearchSuggestionList = false;
        this.navService.ispopUpShow = false;
        // this.loading = false;
      }

    /*} else {

      if(key && key.length != 0 && key.length >= 3){

        this.portalService.getAutocompleteList(keywordBody).subscribe(res => {
          let tempArr:any = [];
          tempArr = res;
          // console.log({'tempArr':tempArr});
          this.suggestions = [];
          
          if(tempArr['data'].length != 0) {
            tempArr['data'].forEach(el => {
              let dataObj = { 'data': null};
              // console.log({'el':el});
              dataObj.data = el.keyword[0];
              this.suggestions.push(dataObj);
            });
          }
          console.log({'suggestions':this.suggestions});

          if(this.suggestions.length != 0) {
              $('.hover_bkgr_fricc').css({ 'display': 'block' });
              // this.suggestions = this.convert2arr(res['_body']);
              this.addHighlight(key);
              this.navService.isSearchSuggestionList = true;
              this.navService.ispopUpShow = true;
          }

        },
        error => {
            console.log(error);
            // this.loading = false;
        //   this.loading = false;
        //   this.commonservice.showError(JSON.parse(error._body).statusDesc, '');
        });
    } else {
      this.navService.isSearchSuggestionList = false;
      this.navService.ispopUpShow = false;
      // this.loading = false;
    }
  } */

  if(this.suggestions.length != 0) {
      $('.hover_bkgr_fricc').css({ 'display': 'block' });
      // this.suggestions = this.convert2arr(res['_body']);
      this.addHighlight(key);
      this.navService.isSearchSuggestionList = true;
      this.navService.ispopUpShow = true;
      // console.log({'suggestions':this.suggestions});
  } else {
      this.navService.isSearchSuggestionList = false;
      this.navService.ispopUpShow = false;
      // this.loading = false;
  }
    
}

addHighlight(keyword) {
    let span1 = document.createElement("span");
    let maintxt;

    this.suggestions.forEach(el => {

        maintxt = el.data;
        // console.log({'maintxt':maintxt});

        if (maintxt !== "null") {
            let nameNode = document.createTextNode(maintxt);
            span1.appendChild(nameNode);
            // console.log({'keyword':keyword});

            let resStr = this.highlight_words(keyword, span1);
            // if(resStr.trim().length > 300){
            //   this.dataHilight = resStr.slice(0,300) + '...';
            // }else{
            // } 
            el.hl = resStr;
            // this.dataHilight = el.data;
            // console.log({'dataHilight':this.dataHilight});
        } else {
            // this.dataHilight = '';
        }
    });

}

highlight_words(word, element) {
    let regex: any = "";
    if (word) {
        var resData;
        word = word.replace(/\W/gi, '');
        var str = word.split(" ");

        $(str).each(function () {
            //   console.log({'str':str});

            var term = str;
            var textNodes = $(element).contents().filter(function () {
                return this.nodeType === 3
            });
            textNodes.each(function () {

                var content = $(this).text();
                regex = new RegExp(term, "gi");

                resData = content.replace(regex, (match) => `<span class="highlightWord">${match}</span>`);
            });
        });
        return resData;
    }
}

}



// WEBPACK FOOTER //
// ./src/app/search/search-result/search-result.component.ts